import { createContext } from 'react';
const QuickActionsContext = /*#__PURE__*/createContext({
  isActive: false,
  setIsActive: () => {}
});
export { QuickActionsContext };